

































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { DeliveryCompany, Warehouse } from 'supporter';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import WeightFee from './WeightFee.vue';
import { ncpPopup } from '@/utils/ncp';
import deliveryTypes from '@/const/words/deliveryTypes';
import deliveryConditionTypes from '@/const/words/deliveryConditionTypes';
import NumberInput from '@/components/common/NumberInput.vue';
@Component({ components: { CompSelectBox, WeightFee, NumberInput } })
export default class DeliveryGroupTemplateAddForm extends Vue {
  private deliveryTypes = deliveryTypes;
  private stateDeliveryConditionTypes = deliveryConditionTypes;
  @Prop({ default: () => [] }) private deliveryCompanyTypes!: DeliveryCompany[];
  @Prop({ default: () => [] }) private warehouses!: Warehouse[];
  @Prop({ default: 'KRW' }) private currencyCode!: string;
  @Prop({ default: false }) private hasDefaultTemplate!: boolean;
  private AMT_MAX_LENGTH = 9;

  private inputErrorFlag = {
    returnDeliveryAmt: false,
  };
  private template: any = {
    default: false,
    name: '',
    deliveryType: 'PARCEL_DELIVERY',
    returnWarehouseNo: undefined,
    deliveryCompanyType: undefined,
    releaseWarehouseNo: undefined,
    deliveryFee: {
      deliveryConditionType: '',
      deliveryAmt: undefined,
      criteria: undefined,
      returnDeliveryAmt: '',
      deliveryFeeRanges: undefined,
    },
  };

  private tempDefaultState: boolean = false;

  get deliveryConditionTypes() {
    return [{ name: 'DELIVERY_GROUP_TEMPLATE_SELECT', value: '' }, ...this.stateDeliveryConditionTypes];
  }

  private validateOnBlur(value?: string): boolean {
    if (this.currencyCode === 'KRW' && Number(value ?? 0) % 10) {
      alert('10원 단위로 입력해주세요.');

      return false;
    }
    return true;
  }

  @Watch('template.deliveryFee.deliveryConditionType')
  onDeliveryConditionTypeChanged() {
    this.template.deliveryFee.criteria = undefined;
    this.template.deliveryFee.deliveryAmt = undefined;
    this.template.deliveryFee.perOrderCnt = undefined;
    this.template.deliveryFee.deliveryFeeRanges =
      this.template.deliveryFee.deliveryConditionType === 'WEIGHT_FEE' ? this.template.deliveryFeeRanges : undefined;
  }

  private closeAddForm() {
    this.$emit('close');
  }
  private openPopup(title: string) {
    title = this.$t(title).toString();
    ncpPopup('/warehouse/addForm', title, 1024, 500);
  }
  private displayGuide() {
    this.$emit('displayGuide');
  }
  private add() {
    const result = this.validation();
    if (result) {
      if (this.template.deliveryFee.deliveryConditionType === 'QUANTITY_PROPOSITIONAL_FEE') {
        this.template.deliveryFee.criteria = 0;
      } else {
        this.template.deliveryFee.perOrderCnt = 0;
      }
      
      // 기본 템플릿이 변경된 경우에만 부모에게 알림
      if (this.tempDefaultState !== this.template.default) {
        this.template.default = this.tempDefaultState;
        this.$emit('defaultTemplateChanged', this.template);
      }
      
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_GUIDE'));
      this.$api.getWarehouses().then(ret => {
        if (ret && ret.data) {
          const releaseWarehouse = (ret.data as any).find(
            warehouse => warehouse.warehouseNo === Number(this.template.releaseWarehouseNo),
          );
          const returnWarehouse = (ret.data as any).find(
            warehouse => warehouse.warehouseNo === Number(this.template.returnWarehouseNo),
          );
          this.template.releaseWarehouse = releaseWarehouse;
          this.template.returnWarehouse = returnWarehouse;
          this.$emit('addTemplate', this.template);
          this.$emit('close');
        }
      });
    }
  }

  private validation() {
    if (!this.template.name) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE1'));
      return false;
    }
    if (!this.template.deliveryFee.deliveryConditionType) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE2'));
      return false;
    }
    if (
      this.template.deliveryFee.deliveryConditionType === 'QUANTITY_PROPOSITIONAL_FEE' &&
      !(Number(this.template.deliveryFee.perOrderCnt) > 0)
    ) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE15'));
      return false;
    }
    if (
      !['FREE', 'WEIGHT_FEE'].includes(this.template.deliveryFee.deliveryConditionType) &&
      !this.template.deliveryFee.deliveryAmt
    ) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE3'));
      return false;
    }

    if (this.template.deliveryFee.deliveryConditionType === 'WEIGHT_FEE') {
      if (!this.template.deliveryFee.deliveryFeeRanges) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE3'));
        return false;
      }
      const isWeightValidate = this.template.deliveryFee.deliveryFeeRanges.every((deliveryFeeRange: any, idx) => {
        if (idx === this.template.deliveryFee.deliveryFeeRanges.length - 1) {
          return deliveryFeeRange.aboveOrEqual;
        }
        return deliveryFeeRange.aboveOrEqual && deliveryFeeRange.below;
      });

      const isAmountValidate = this.template.deliveryFee.deliveryFeeRanges.every(deliveryFeeRange => {
        if (typeof deliveryFeeRange.deliveryAmt === 'number') {
          return deliveryFeeRange.deliveryAmt >= 0;
        }
        return deliveryFeeRange.deliveryAmt;
      });

      if (!isWeightValidate) {
        alert('중량을 설정해주세요.');
        return false;
      }

      if (!isAmountValidate) {
        alert('배송비를 설정해주세요.');
        return false;
      }
    }

    if (!this.template.releaseWarehouseNo) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE4'));
      return false;
    }
    if (!this.template.returnWarehouseNo) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE5'));
      return false;
    }
    if (!this.template.deliveryFee.returnDeliveryAmt) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE6'));
      return false;
    }

    return true;
  }
  checkNumber(e: Event, type: string) {
    let value: any = (e.target as HTMLInputElement).value;
    if (!value.match(/[^\d]/g)) {
      return;
    } else {
      value = Number(value.replace(/[^\d]/g, ''));
    }
    switch (type) {
      case 'returnDeliveryAmt':
        this.inputErrorFlag.returnDeliveryAmt = true;
        this.template.deliveryFee.returnDeliveryAmt = value;
        break;
      case 'criteria':
        this.template.deliveryFee.criteria = value;
        break;
      case 'perOrderCnt':
        this.template.deliveryFee.perOrderCnt = value;
        break;
      case 'deliveryAmt':
        this.template.deliveryFee.deliveryAmt = value;
        break;
      default:
        break;
    }
  }

  private created() {
    this.tempDefaultState = !this.hasDefaultTemplate;
  }
}
